import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Loading({ message }) {
  const { t } = useTranslation();
  return (
    <div className="loading-panel" role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden="true" />
      <p className="loading-message">{message || t('common.loading')}</p>
    </div>
  );
}
